/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{width:100%;height:90vh;display:flex;justify-content:center;align-items:center;overflow:hidden}.wrapper[_ngcontent-%COMP%]{display:flex;margin:auto;flex-direction:column;justify-content:center}h2[_ngcontent-%COMP%]{margin:auto}\n/*# sourceMappingURL=unauthorized.component.css.map*/"];
export { styles as styles };
